import {
  Grid,
  Typography,
  Button,
  CircularProgress,
  Backdrop,
  styled,
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import FilterAeroline from './FilterAeroline';
import FillterBaggage from './FillterBaggage';
import FillterScales from './FillterScales';
import FillterPrices from './FillterPrices';
import FillterDuration from './FillterDuration';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
}));

const FilterContent = ({
  flightFilters,
  sxStyle,
  theme,
  isDesktop,
  drawerMode,
  handleCloseDrawer,
}) => {
  const { isLoadingFilters, handleClearFilters } = flightFilters;

  return (
    <Grid
      container
      item
      xs={12}
      md={3}
      sx={{
        ...sxStyle.root,
        ...(drawerMode && {
          maxWidth: '100%',
          padding: 2.5,
          border: 'none',
          boxShadow: 'none',
        }),
      }}
    >
      {/* HEADER */}
      <Grid item container sx={sxStyle.filterTitleContainer}>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 20,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {!isDesktop && <ArrowBackIosIcon onClick={handleCloseDrawer} />}
          Filtros
        </Typography>

        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 16,
            color: theme.tertiary,
            cursor: 'pointer',
          }}
          onClick={handleClearFilters}
        >
          Limpiar
        </Typography>
      </Grid>

      <Grid sx={sxStyle.filterBoxContainer} item>
        <FilterAeroline flightFilters={flightFilters} />
        <FillterBaggage flightFilters={flightFilters} />
        <FillterScales flightFilters={flightFilters} />
        <FillterPrices flightFilters={flightFilters} />
        <FillterDuration flightFilters={flightFilters} />

        {!isDesktop && (
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Button
              variant="contained"
              size="large"
              onClick={handleCloseDrawer}
              sx={sxStyle.filterButtonn}
            >
              Aplicar filtros
            </Button>
          </Grid>
        )}
      </Grid>

      {isLoadingFilters && (
        <StyledBackdrop open>
          <CircularProgress color="inherit" />
        </StyledBackdrop>
      )}
    </Grid>
  );
};

export default FilterContent;
